import { useEffect, useState } from 'react';
import { AxiosError, AxiosPromise } from 'axios';

const useAxios = <T extends any>(promise?: AxiosPromise<T>) => {
  const [data, setData] = useState<T | undefined>(undefined);
  const [arr, setArr] = useState<T[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<AxiosError | undefined>(undefined);

  useEffect(() => {
    if (promise) execute(promise);
  }, []);

  const execute = async (promise: AxiosPromise<T>, init = true) => {
    setError(undefined);
    init && setData(undefined);
    setIsLoading(true);
    try {
      const { data } = await promise;
      setData(data);
    } catch (e) {
      const error = e as AxiosError;
      setError(error);
    }
    setIsLoading(false);
  };

  const executeArr = async (promise: AxiosPromise<T>[]) => {
    setError(undefined);
    setData(undefined);
    setIsLoading(true);
    try {
      const newArr: T[] = [];
      const results = await Promise.all(promise);
      results.forEach(({ data }) => newArr.push(data));
      setArr(newArr);
    } catch (e) {
      setError(e as AxiosError);
    }
    setIsLoading(false);
  };

  const clear = () => setData(undefined);

  return {
    data,
    arr,
    isLoading,
    error,
    execute,
    executeArr,
    clear,
  };
};

export default useAxios;
